import React from 'react';
import { WtUi } from 'wt-ui';
import { useTranslation } from 'react-i18next';
import Calendar from '../Calendar';

import ErrorBoundary from '../../components/ErrorBoundary';

// we need to initialize our i18n module
// eslint-disable-next-line no-unused-vars
import i18n from '../../translations/i18n';

import newrelic from './newrelic';
import heap from '../../services/heap';

newrelic.init();
heap.init();
heap.track('LoadCalendar');

const App = () => {
  const { i18n: _i18n } = useTranslation();
  const siteCoreLang = (window.myApp && window.myApp.isoCode) || 'en-GB';
  _i18n.changeLanguage(siteCoreLang);

  return (
    <WtUi>
      <ErrorBoundary>
        <span data-version={process.env.REACT_APP_VERSION} />
        <span data-commit-hash={process.env.REACT_APP_COMMIT_HASH} />
        <Calendar />
      </ErrorBoundary>
    </WtUi>
  );
};

export default App;
